import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { apiCall, removeParam } from '../../utils';
import Swal from 'sweetalert2';


const IntegrationContaAzul = () => {
  const [branches, setBusinessBranches] = useState([]);
  const [branchesUpdated, setBranchesUpdated] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const interval = useRef(null);

  const initData = () => {
    let userProfileResponse = { ...window._sessionData };
    if (!Array.isArray(userProfileResponse.businessBranches)) {
      userProfileResponse.businessBranches = Object.keys(userProfileResponse.businessBranches).map((key) => {
        return userProfileResponse.businessBranches[key];
      });
    }
    setBusinessBranches(userProfileResponse.businessBranches);
    clearInterval(interval.current);

    console.log('branches', branches);
  }

  React.useEffect(() => {
    interval.current = setInterval(() => {
      if (window._sessionData.businessBranches && branches.length === 0) {
        initData();
      }
    }, 1000);
  }, []);

  console.log('branches', branches);
  console.log('branchesUpdated', branchesUpdated);

  const saveUpdatedBranch = (branchId) => {
    const branch = branchesUpdated.find((branch) => branch.ID === branchId);
    if (!branch) return;

    Swal.fire({
        title: 'Deseja salvar o token de acesso?',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        showLoaderOnConfirm: true,
    }).then((result) => {
        if (result.isConfirmed) {
            updateAccessToken(branch);
        }
    });
    /*setIsLoading(true);
    apiCall({
      method: 'POST',
      endpoint: 'api/v1/integrations/autentique/update-access-token',
      data: branch,
      successCallback: function(res) {
        window.toast({
          error: res.error,
          text: res.message
        })
      },
        errorCallback: function(err) {
            window.toast({
            error: true,
            text: 'Erro ao salvar token de acesso'
            })
        }
    });*/
  }

  const updateAccessToken = (branch) => {
    return new Promise((resolve) => {
        setIsLoading(true);

        let data = branchesUpdated.find((branch2) => branch2.ID == branch.ID);

        apiCall({
            method: 'POST',
            endpoint: 'api/v1/integrations/autentique/update-access-token',
            data: data,
            successCallback: function(res) {
                console.log('res', res);
                const newBranches = branches.map((branch) => {
                    if (branch.ID === branchId) {
                        branch.METADATA.integrations.autentique.access_token = branchesUpdated.find((branch) => branch.ID === branchId).integrations.autentique.access_token;
                    }
                    return branch;
                });
                setBusinessBranches(newBranches);

                // remove from branchesUpdated
                const newBranchesUpdated = branchesUpdated.filter((branch) => branch.ID !== branchId);
                setBranchesUpdated(newBranchesUpdated);

                setIsLoading(false);

                Swal.fire({
                    title: 'Token de acesso salvo com sucesso',
                    icon: 'success'
                });

                resolve();
            },
            errorCallback: function(err) {
                Swal.fire({
                    title: 'Ocorreu um erro ao salvar token de acesso.',
                    icon: 'error'
                });
                setIsLoading(false);
                resolve();
            }
        });
    });
  }

  return (
    <>
        <table className="table table-striped table-bordered">
            <thead>
                <tr>
                    <th>Filial</th>
                    <th>Token de Acesso</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {branches.map((branch, index) => (
                    <tr key={index}>
                        <td>{branch.FILIAL}</td>
                        <td>
                            <input 
                                type="text" 
                                className="form-control" 
                                data-branch-id={branch.ID} 
                                data-old-value={branch.METADATA.integrations?.autentique?.access_token || ''}
                                placeholder="Token de Acesso"
                                value={branch.METADATA.integrations?.autentique?.access_token}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const branchId = e.target.getAttribute('data-branch-id');

                                    if (value === e.target.getAttribute('data-old-value')) {
                                        // remove from new branches
                                        const newBranches = branchesUpdated.filter((branch) => branch.ID !== branchId);
                                        setBranchesUpdated(newBranches);
                                        return;
                                    }

                                    // check if branch exists in branchesUpdated
                                    const branchExists = branchesUpdated.find((branch) => branch.ID === branchId);

                                    if (branchExists) {
                                        const newBranches = branchesUpdated.map((branch) => {
                                            if (branch.ID === branchId) {
                                                branch.integrations.autentique.access_token = value;
                                            }
                                            return branch;
                                        });
                                        setBranchesUpdated(newBranches);
                                    } else {
                                        const newBranches = branchesUpdated;
                                        newBranches.push({
                                            ID: branchId,
                                            integrations: {
                                                autentique: {
                                                    access_token: value
                                                }
                                            }
                                        });
                                        setBranchesUpdated(newBranches);
                                    }
                                }}
                            />
                        </td>
                        <td>
                            {
                                branchesUpdated.find((branch2) => branch2.ID === branch.ID)
                                ? <button className="btn btn-primary" onClick={() => { saveUpdatedBranch(branch.ID) }}>Salvar Alteração</button>
                                : null
                            }
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </>
  );
}

try {
    if (document.getElementById('js-autentique-integration-container')) {
      const container = document.getElementById('js-autentique-integration-container');
      const root = createRoot(container); // createRoot(container!) if you use TypeScript
      root.render(<IntegrationContaAzul />);
    }
  } catch(err) {
    console.error('Error rendering IntegrationContaAzulPage: ', err);
  }